import { useMemo } from 'react';
import { Link, type LinkProps } from 'react-router';
import { useOrganizationStore } from '@/stores/organization-store';

export const OLink = ({ to, ...props }: LinkProps) => {
  const { currentOrganization } = useOrganizationStore();

  const buildTo = (pathTo: string) => {
    const opath = `/o/${currentOrganization.id}`;
    return pathTo.startsWith('/') ? `${opath}${pathTo}` : pathTo;
  };

  const linkTo = useMemo(() => {
    if (typeof to === 'string') {
      return buildTo(to);
    }
    return {
      ...to,
      pathname: to.pathname ? buildTo(to.pathname) : undefined,
    };
  }, [currentOrganization.id, to]);

  return <Link to={linkTo} {...props} />;
};
